<template lang="pug">
#app
  v-layout(row, wrap, v-if="pedido")
    v-flex.xs12
      v-card(flat, :class="color", style="box-shadow: none!important;")
        v-card-text
          div(id="printContent")
            .panel-print
              .text-center
                h3
                  center(v-if="pedido.cardapio_digital == 0") BIGOU DELIVERY
                  center(v-if="pedido.cardapio_digital == 1") CARDÁPIO DIGITAL
                br
              label(style='font-weight: normal;')
                strong FORNECEDOR:
                |  {{ pedido.estabelecimento.nome | removeAccents | uppercase }}
              br
              label(style='font-weight: normal;')
                strong PEDIDO:
                |  {{ pedido.id }}
              br
              label(v-if="pedido.integracao_id" style='font-weight: normal;')
                strong CÓDIGO PDV:
                |  {{ pedido.integracao_id }}
              br
              label(style='font-weight: normal;')
                strong DATA:
                |  {{ $dayjs(pedido.data).format("DD/MM/YYYY HH:mm") }}
              br(v-if="pedido.status !== 3 && pedido.status !== 0 && previsao")
              label(style='font-weight: normal;', v-if="pedido.status !== 3 && pedido.status !== 0 && previsao")
                strong PREVISAO DE {{ pedido.endereco_id == -1 ? 'RETIRADA' : 'ENTREGA' }}:
                |  {{ $dayjs(previsao).format("DD/MM/YYYY HH:mm") }}
              br
              div(v-if='pedido.status == 3 && pedido.motivo && $root.showIdentify(pedido)')
                br
                #linha1
                #linha0
                #linha0
                #linha0
                #linha0
                #linha0
                strong
                  center MOTIVO DO CANCELAMENTO
                #linha0
                #linha0
                #linha0
                #linha0
                #linha0
                #linha1
                #linha0
                #linha0
                #linha0
                #linha0
                #linha0
                span
                  label(style='font-weight: normal;') {{ pedido.motivo  | removeAccents | uppercase }}
              br
              #linha1
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              strong
                center DADOS DA ENTREGA
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              #linha1
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              span(v-if='$root.showIdentify(pedido)')
                label(style='font-weight: normal;')
                  strong CLIENTE:
                  |  {{ pedido.usuario.nome  | removeAccents | uppercase }}
                br
                label(style='font-weight: normal;')
                  strong TELEFONE:
                  |  {{ pedido | telefone }}
                br
              strong ENDERECO:
              |  {{ pedido.endereco | endereco  | removeAccents | uppercase }}
              br
              label(v-if="pedido.endereco.referencia && pedido.endereco.referencia !== ''", style='font-weight: normal;')
                strong REFERENCIA:
                |  {{ pedido.endereco.referencia  | removeAccents | uppercase }}
              br
              br
              #linha1
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              strong
                center ITENS DO PEDIDO
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              #linha1
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              div(v-for='(itemPedido, index) in pedido.itens', :key="index")
                table(style='width:100%')
                  tr
                    td(style='width:7%;')
                      strong {{ itemPedido.quantidade }} x
                    td
                      span.font-weight-medium {{ itemPedido.item.categoria  | removeAccents | uppercase }}:
                      span {{ itemPedido.item.nome  | removeAccents | uppercase }}
                      strong(v-if='itemPedido.quantidade > 1') ({{ itemPedido.quantidade }} x {{ itemPedido.preco_base | currency }})
                      br
                      small(v-if="itemPedido.item.cod_bar")
                        b CÓDIGO:
                      small.pb-3(v-if="itemPedido.item.cod_bar") {{ itemPedido.item.cod_bar }}

                    td(align='right') {{ (itemPedido.preco_base * itemPedido.quantidade).toFixed(2) | currency }}
                div(v-for="(itemVariacao, index2) in $root.variacoesPadrao(itemPedido.variacoes)", :key="index2")
                    table(style='width:100%')
                      tr
                        td(style='width:7%;')
                        td#var
                          small
                            span.font-weight-medium - {{ itemVariacao.variacao.nome  | removeAccents | uppercase }}:
                            span {{ itemVariacao.item.nome  | removeAccents | uppercase }}
                            b(v-if='itemVariacao.mod_preco == 1 && itemPedido.quantidade > 1') ({{ itemPedido.quantidade }} x {{ itemVariacao.preco | currency }})
                        td(align='right' v-if='itemVariacao.mod_preco == 1 && itemVariacao.preco > 0')
                          small + {{ (itemVariacao.preco * itemPedido.quantidade).toFixed(2) | currency }}
                span(v-if='itemPedido.observacao')
                  strong OBS.:
                  span {{ itemPedido.observacao | removeAccents | uppercase }}
                  br
              br
              div(v-if="pedido.observacao && pedido.observacao !== ''")
                #linha1
                #linha0
                #linha0
                #linha0
                #linha0
                #linha0
                strong
                  center   OBSERVACAO DO PEDIDO
                #linha0
                #linha0
                #linha0
                #linha0
                #linha0
                #linha1
                #linha0
                #linha0
                #linha0
                #linha0
                #linha0
                span
                  | {{ pedido.observacao | removeAccents | uppercase }}
                  br
                  br
              #linha1
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              strong
                center   PAGAMENTO
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              #linha1
              #linha0
              #linha0
              #linha0
              #linha0
              #linha0
              div(style="width:100%")
                div(style="float: left")
                  strong SUBTOTAL:
                div(style="float: right") {{ pedido.subtotal | currency }}
              br(v-if='pedido.endereco_id > 0')
              div(style="width:100%", v-if='pedido.endereco_id > 0')
                div(style="float: left")
                  strong TAXA DE ENTREGA:
                div(style="float: right") {{ pedido.taxa_entrega | currency }}
              br(v-if="pedido.taxa_servico")
              div(style="width:100%; display: flex; justify-content: space-between; align-items: baseline", v-if="pedido.taxa_servico")
                div(style="float: left")
                  strong TAXA DE SERVIÇO:
                  v-icon(@click="openHelperTaxaServico()").clicable.pl-1 info

                div(style="float: right") {{ pedido.taxa_servico | currency }}
              br(v-if="pedido.taxa_servico")
              br(v-if='pedido.cupom_desconto_id')
              div(style="width:100%", v-if='pedido.cupom_desconto_id')
                div(style="float: left")
                  strong CUPOM DESCONTO{{ pedido.estabelecimento_cupom == 1 ? ` (${pedido.cupomDesconto.codigo})` : '' }}:
                div(style="float: right")  - {{ pedido.desconto | currency }}
              br
              div(style="width:100%")
                div(style="float: left")
                  strong TOTAL:
                div(style="float: right")
                  strong {{ pedido.total | currency }}
              br
              div(style="width:100%", v-if='!showPagamento')
                br
                strong
                  center A FORMA DE PAGAMENTO SERÁ EXIBIDA APÓS A CONFIRMAÇÃO DO PEDIDO

              div(style="width:100%", v-if='showPagamento')
                div(style="float: left")
                  strong FORMA DE PAGAMENTO:
                div(style="float: right") {{ pedido.formaPagamento.nome | removeAccents | uppercase }}
              div(v-if='showPagamento')
                br(v-if='pedido.troco && pedido.forma_pagamento_id == 1')
                div(style="width:100%", v-if='pedido.troco && pedido.forma_pagamento_id == 1')
                  div(style="float: left")
                    strong PAGAMENTO:
                  div(style="float: right") {{ pedido.troco | currency }}
                br(v-if='pedido.troco && pedido.forma_pagamento_id == 1')
                div(style="width:100%", v-if='pedido.troco && pedido.forma_pagamento_id == 1')
                  div(style="float: left")
                    strong TROCO:
                  div(style="float: right") {{ (pedido.troco - pedido.total) | currency }}
              br
              #linha0
              #linha0
              #linha0
              #linha1
              #linha0
              #linha0
              font(size='2')
                center CUPOM NAO FISCAL
                center(v-if="pedido.cardapio_digital == 0") WWW.BIGOU.COM.BR
              br
              br
              br
              label(style='font-weight: normal;') &nbsp;
  DialogTipTaxaServico(ref="dialogTipTaxaServico")
</template>

<script>
import DialogTipTaxaServico from '@/components/dialog/DialogTipTaxaServico';

export default {
  components: {
    DialogTipTaxaServico
  },
  props: {
    pedido: {
      type: Object,
      default: null,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: 'ticket',
    },
  },
  computed: {
    previsao () {
      return this.pedido.tempo_entrega ? this.$dayjs(this.pedido.data).add(this.pedido.tempo_entrega, 'minutes') : null;
    },
    showPagamento(){
      return this.pedido.status == 1 || this.pedido.status == 2 || this.pedido.cardapio_digital == 1;
    }
  },
  methods: {
    openHelperTaxaServico(){
      const vm = this;
      vm.$refs.dialogTipTaxaServico.open();
    }
  }
}
</script>

<style lang="scss" scoped>
#linha0 {
  width: 0%;
  border-bottom: 1px solid #000000;
}

#linha1 {
  width: 100%;
  border-bottom: 1px solid #000000;
}
</style>
